import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { HandlingUnitType, PharosPaginatedResponse } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { createHandlingUnitTypeApi, handlingUnitTypeKeys } from '../api';
import type { SearchHandlingUnitTypesParams } from '../api';

export interface UseHandlingUnitTypesOptions extends SearchHandlingUnitTypesParams {
  enabled?: boolean;
}

export function useHandlingUnitTypes(
  params: UseHandlingUnitTypesOptions,
): UseQueryResult<PharosPaginatedResponse<HandlingUnitType>> {
  const { enabled = true, ...listParams } = params;
  const client = useApiClient('admin-auth');
  const api = createHandlingUnitTypeApi(client);

  return useQuery({
    enabled,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.searchHandlingUnitTypes(listParams),
    queryKey: handlingUnitTypeKeys.list(listParams),
    staleTime: LIST_STALE_TIME_MS,
  });
}
